import redArrowIcon from "./red-arrow.svg";
function RedArrow() {
  return <img width={"25"} height={"25"} src={redArrowIcon} alt="excel-svg" />;
}

export default RedArrow;
